import { TEST } from "../actions/types";
import testReducer from "../reducers/test";
import { removeBrokenLogics, validateLogics } from "../utills/logicUtils";

export const LogicVerificationMiddleware = store => next => action => {
    if (action.type === TEST.UPDATE) {
        const clonedState = { ...store.getState().test };
        const updatedState = testReducer(clonedState, action);

        const logicValidationMap = validateLogics(updatedState?.data?.tasks);
        const allValid = Object.values(logicValidationMap).every(item => item.isValid);
        if (allValid) return next(action);
        else {
            store.dispatch({
                type: TEST.SHOW_UPDATE_CONFIRMATION_MODAL, payload: {
                    show: true,
                    errorMessage: logicValidationMap,
                    onProceed: () => {
                        const updatedTasks = removeBrokenLogics(logicValidationMap, updatedState?.data?.tasks);
                        store.dispatch({ type: TEST.UPDATE, payload: { data: { ...updatedState?.data, tasks: updatedTasks } } });
                    },
                    onCancel: () => {
                        store.dispatch({ type: TEST.UPDATE, payload: { ...clonedState } });
                    }
                }
            });
        }
    }

    return next(action);
};